import { useEffect, useState } from "react";
import api from "../lib/api";
import { EpisodeCard } from "../components/EpisodeCard";
import { CATEGORIES } from "../lib/utils2";
import { Search } from "lucide-react";

export default function Archive() {
  const [episodes, setEpisodes] = useState([]);
  const [category, setCategory] = useState("Tutte");
  const [search, setSearch] = useState("");

  const load = () => {
    const params = {};
    if (category !== "Tutte") params.category = category;
    if (search) params.search = search;
    api.get("/episodes", { params }).then((r) => setEpisodes(r.data));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [category]);

  return (
    <div>
      <section className="bg-navy py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-white">Archivio Episodi</h1>
          <p className="text-slate-300 mt-4 max-w-2xl mx-auto text-lg">Tutti gli episodi del podcast, filtrabili per argomento normativo.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative max-w-xl mx-auto mb-8">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} data-testid="search-input"
            placeholder="Cerca per titolo o argomento..."
            className="w-full pl-12 pr-4 py-3.5 rounded-full border border-slate-200 focus:outline-none focus:border-navy bg-white" />
        </form>

        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {CATEGORIES.map((c) => (
            <button key={c} onClick={() => setCategory(c)} data-testid={`filter-${c}`}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${category === c ? "bg-navy text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
              {c}
            </button>
          ))}
        </div>

        {episodes.length === 0 ? (
          <p className="text-center text-slate-400 py-16">Nessun episodio trovato.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {episodes.map((ep) => <EpisodeCard key={ep.id} ep={ep} />)}
          </div>
        )}
      </div>
    </div>
  );
}
